const domainDataReducer = (state=[], action) => {
    switch(action.type){
        case 'FETCH_ALL_DOMAIN_DATA':
            return action.payload
        default:
            return state
    }
}
export default domainDataReducer;